var _path, _path2, _g, _path3, _g2, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKakaoAdvertisementMallTextImageDummy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3501 35.0375C19.3501 33.0493 20.9619 31.4375 22.9501 31.4375H29.9251V46.5448H22.9501C20.9619 46.5448 19.3501 44.9329 19.3501 42.9447V35.0375Z",
    fill: "#FFE500"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5586_198458",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 31,
    width: 11,
    height: 16
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3501 35.0375C19.3501 33.0493 20.9619 31.4375 22.9501 31.4375H29.9251V46.5448H22.9501C20.9619 46.5448 19.3501 44.9329 19.3501 42.9447V35.0375Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5586_198458)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1001 35.0375C17.1001 31.8067 19.7192 29.1875 22.9501 29.1875H29.9251V33.6875H22.9501C22.2045 33.6875 21.6001 34.292 21.6001 35.0375H17.1001ZM29.9251 48.7948H22.9501C19.7192 48.7948 17.1001 46.1758 17.1001 42.9447H21.6001C21.6001 43.6903 22.2045 44.2947 22.9501 44.2947H29.9251V48.7948ZM22.9501 48.7948C19.7192 48.7948 17.1001 46.1758 17.1001 42.9447V35.0375C17.1001 31.8067 19.7192 29.1875 22.9501 29.1875V33.6875C22.2045 33.6875 21.6001 34.292 21.6001 35.0375V42.9447C21.6001 43.6903 22.2045 44.2947 22.9501 44.2947V48.7948Z",
    fill: "#2E2E30"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_5586_198458",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 42,
    width: 15,
    height: 20
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9248 42.7656H43.5212V54.8512C43.5212 58.606 40.4776 61.6494 36.723 61.6494C32.9685 61.6494 29.9248 58.606 29.9248 54.8512V42.7656Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_5586_198458)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.9248 42.7656H43.5212V54.8512C43.5212 58.606 40.4776 61.6494 36.723 61.6494C32.9685 61.6494 29.9248 58.606 29.9248 54.8512V42.7656Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9248 42.7656V40.5156H27.6748V42.7656H29.9248ZM43.5212 42.7656H45.7711V40.5156H43.5212V42.7656ZM29.9248 45.0156H43.5212V40.5156H29.9248V45.0156ZM41.2712 42.7656V54.8512H45.7711V42.7656H41.2712ZM32.1748 54.8512V42.7656H27.6748V54.8512H32.1748ZM36.723 59.3994C34.2111 59.3994 32.1748 57.3631 32.1748 54.8512H27.6748C27.6748 59.8485 31.7258 63.8994 36.723 63.8994V59.3994ZM41.2712 54.8512C41.2712 57.3631 39.2349 59.3994 36.723 59.3994V63.8994C41.7202 63.8994 45.7711 59.8485 45.7711 54.8512H41.2712Z",
    fill: "#2E2E30"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0498 45.7704V32.2137L59.6095 21.3339C60.0514 21.1656 60.5248 21.4919 60.5248 21.9646V56.0192C60.5248 56.4921 60.0514 56.8184 59.6095 56.6501L31.0498 45.7704Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.2748 22.7924L32.2998 33.0685V44.9023L59.2748 55.1783V22.7924ZM59.1646 20.1591C60.4245 19.6792 61.7748 20.6096 61.7748 21.9579V56.0125C61.7748 57.3608 60.4248 58.2915 59.1646 57.8116L29.7998 46.6252V31.3456L59.1646 20.1591Z",
    fill: "#2E2E30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKakaoAdvertisementMallTextImageDummy);
export default __webpack_public_path__ + "static/media/kakao_advertisement_mall_text_image_dummy.bbfe57d3a9bb5e06dcbf09c332cc992c.svg";
export { ForwardRef as ReactComponent };